<template>
<div id="removeclass">
  <modal
    :modal-id="modalId"
    :title="modalTitle"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
  >
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="addurl"
      >
        <div class="form-group row align-items-center">
          <label class="col-sm-3 mb-0">{{ $t("category_name") }}</label>
          <app-input
            class="col-sm-9"
            type="text"
            v-model="inputs.name"
          />
        </div>
      </form>
    </template>
  </modal>
</div>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../Mixins/ModalMixin";
import * as actions from "../../../../Config/ApiUrl";
import {
  axiosPost,
  axiosDelete,
  axiosGet,
} from "../../../../Helpers/AxiosHelper.js";
import AppLibrary from "../../../../Helpers/AppLibrary";

export default {
  name: "AddModal",
  extends: AppLibrary,
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    caregoryId: Number,
  },
  data() {
    return {
      documentCategories: [],
      addurl: actions.DOCUMENT_CATEGORY_STORE,
      preloader: false,
      inputs: {},
      modalId: "demo-add-edit-category-Modal",
      modalTitle: this.$t("add"),
    };
  },
  created() {
    if (this.selectedUrl) {
      this.modalTitle = this.$t("edit");
      this.addurl = actions.DOCUMENT_CATEGORY_UPDATE;
    }
  },
  methods: {
    submit() {

        this.inputs.is_parent = this.caregoryId;
        let formData = new FormData();
        Object.keys(this.inputs).forEach((key) => {
          formData.append(key,this.inputs[key]);
        });
        if (this.selectedUrl) {
            axiosPost(this.addurl, formData)
          .then((res) => {
            
            this.afterSuccess(res);
          })
          .catch((error) => {
            this.$toastr.e(error);
          })
          .finally(() => {
            this.preloader = false;
            $("#demo-add-edit-category-Modal").modal("hide");
          });

        }
        else {
            this.save(formData);
        }
    },
    afterSuccess(response) {
      this.$toastr.s(response.data.message);
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      // if (response.data.phone) this.phone = response.data.phone;
      this.inputs = response.data;
      this.preloader = false;
    },
  },

  mounted() {
    $(function () {
      $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
    });
  },
};
</script>
